export const createDatagridStyleOverrides = (resolvedRoles) => {
    const internalBorderColor = resolvedRoles['table.row.unselected.default.borderColor'];
    const externalBorderColor = resolvedRoles['table.cell.unselected.default.borderColor'];
    const selectedColumnBorderColor = resolvedRoles['table.cell.selected.default.borderColor'];
    const borderWidth = resolvedRoles['table.borderWidth'];
    return {
        root: {
            color: resolvedRoles['table.fontColor'],
            '& .selected-column': {
                borderLeft: `${borderWidth} dashed ${internalBorderColor}`,
                borderRight: `${borderWidth} dashed ${internalBorderColor}`,
            },
            '& .selected-column-top': {
                borderTop: `${borderWidth} dashed ${internalBorderColor}`,
            },
            '& .selected-column-bottom': {
                borderBottom: `3px dashed ${internalBorderColor}`,
            },
            '&.Mui-selected': {
                backgroundColor: 'transparent',
                borderColor: selectedColumnBorderColor,
            },
            '& .MuiDataGrid-cell': {
                backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                borderBottomWidth: borderWidth,
                paddingTop: 0,
                paddingBottom: 0,
                height: resolvedRoles['table.header.minHeight'],
            },
            '& .MuiDataGrid-columnHeaders': {
                backgroundColor: `${resolvedRoles['table.header.backgroundColor']}`,
                color: `${resolvedRoles['table.header.iconColor']}`,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            '& .MuiDataGrid-pinnedColumnHeaders': {
                backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-pinnedColumns': {
                backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-row': {
                border: `1px dashed ${internalBorderColor}`,
                '&:last-of-type': {
                    borderBottom: `3px solid ${externalBorderColor}`,
                },
            },
        },
    };
};
